import Select, { SelectMenuItem } from './Select';

export default Select;
export type { SelectMenuItem };
